import { create } from "zustand";
import { makeRequest } from "../utils/makeRequest";

interface AssistantSubscriptionState {
  // Whether the logged-in assistant holds an active Assistant Subscription; null until the
  // first read lands. Shared so the sidebar's "Select an advisor to work for" dropdown and the
  // assistant's own Subscription tab never disagree - a purchase there unlocks the dropdown.
  isActive: boolean | null;
  setIsActive: (isActive: boolean) => void;
  fetchSubscriptionStatus: () => Promise<void>;
}

export const useAssistantSubscriptionStore = create<AssistantSubscriptionState>((set) => ({
  isActive: null,
  setIsActive: (isActive) => set({ isActive }),
  fetchSubscriptionStatus: async () => {
    try {
      // `/assistant-subscription` always goes out with the assistant's own token (see the
      // makeRequest interceptor), even while acting as an advisor. The timestamp busts the
      // endpoint's ETag, whose 304 would otherwise hand back a stale pre-purchase body.
      const response = await makeRequest("assistantSubscription").get(
        `_=${Date.now()}`,
        false,
        true,
      );
      set({ isActive: response?.data?.data?.active === true });
    } catch {
      // A failed check keeps the assistant locked out rather than granting access.
      set({ isActive: false });
    }
  },
}));
